import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { callGet, Retrieving } from 'helpers/apiTypes';
import { prepareForBackend, toArrayOfIdObject } from 'helpers/objects';

export type IMenu = API['Menu']['read'];
export type IMenuCreate = API['Menu']['create'];
export type IMenuUpdate = API['Menu']['update'] & {
  itemsOverwrite?: { id: number }[];
};

function prepareForUpdate(menu: IMenu): IMenuUpdate {
  const updated = prepareForBackend(menu, ['id']) as IMenuUpdate;
  updated.itemsOverwrite = toArrayOfIdObject(menu.items);
  return updated;
}
function prepareForCreate(menu: IMenu): IMenuCreate {
  return prepareForBackend(menu, ['id']) as IMenuCreate;
}

export const fetchMenus = async () => {
  try {
    const query = {
      '*': true,
      items: {
        '*': true,
        menu: {
          id: true,
        },
      },
    } as const satisfies Retrieving<'Menu'>;
    const response = await callGet('Menu', query);
    return response.response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const postMenu = async (data: IMenu) => {
  try {
    const response: any = await api.post('Menu', prepareForCreate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchMenu = async (data: IMenu) => {
  try {
    const response = await api.patch('Menu/' + data.id, prepareForUpdate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const deleteMenu = async (id: number) => {
  try {
    const response: any = await api.delete('Menu/' + id);
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};
